<script setup>
import { computed, inject, onBeforeUnmount, onMounted, watch } from 'vue'
import SzwImage from '@/__v1.5__/components/image/Image.vue'
import useTabNavigation from '@/__core__/composables/useTabNavigation'
import Tabs from '@/__core__/components/navigation/tabs/Tabs.vue'

const props = defineProps({
  logoUrl: String,
  title: String,
  subtitle: String,
  hasShadow: Boolean,
  tabs: {
    type: Array,
    default: () => []
  },
  width: Number,
  disableTabs: Boolean,
  langId: String
})

const status = inject('status')

const emit = defineEmits(['tab-changed'])

const wrapperClasses = computed(() => 'szw-flex szw-w-full szw-bg-latest-background szw-rounded-2 szw-items-center szw-p-2')

const { initialize: initTabs, tabs: navigation, changeTab } = useTabNavigation([], props.langId)

function emitTabClicked(tab) {
  emit('tab-changed', tab)
  changeTab(tab)
}

const unwatch = watch(() => props.tabs, initTabs)

onMounted(() => {
  initTabs(props.tabs)
})

onBeforeUnmount(unwatch)
</script>

<template>
  <div class="szw-flex szw-flex-col szw-w-full szw-items-center szw-gap-2 szw-rounded szw-pb-1" style="box-shadow: 0px 3px 4px 0px #00000026">
    <div v-if="status === 'loading'" :class="wrapperClasses">
      <div class="szw-flex szw-flex-col szw-gap-1">
        <span class="szw-h-[22px] szw-w-[150px] szw-rounded szw-bg-latest-background-color-secondary szw-animate-pulse" />
        <span class="szw-h-[16px] szw-w-[50px] szw-rounded szw-bg-latest-background-color-secondary szw-animate-pulse" />
      </div>

      <div class="szw-ml-auto szw-my-auto szw-w-[92px] szw-h-[92px] szw-rounded-full szw-bg-latest-background-color-secondary szw-animate-pulse" />
    </div>

    <div v-else :class="wrapperClasses">
      <div class="szw-flex szw-flex-col szw-gap-1" style="max-width: calc(100% - 92px - 4px)">
        <span class="szw-font-bold szw-leading-2xl szw-text-font-size-2xl">{{ title }}</span>
        <span class="szw-leading-md szw-leading-md szw-text-font-size-md">{{ subtitle }}</span>
      </div>

      <div class="szw-ml-auto szw-my-auto">
        <szw-image :src="logoUrl" alt="caption-logo" class="szw-h-[92px] szw-w-[92px] szw-text-font-size-xl" :fallback-content="title" />
      </div>
    </div>

    <tabs
      v-if="!disableTabs && navigation.length"
      :tabs="navigation"
      :tabs-number="navigation.length"
      @tab-clicked="emitTabClicked"
      :classes="'szw-w-full szw-justify-center'"
      class="szw-w-full szw-mx-auto szw-min-h-[32px] szw-max-h-[32px] szw-h-[32px] szw-px-1"
    />
    <slot />
  </div>
</template>
